export enum ReadyToSendModalExperimentVariant {
  CONTROL = "control",
  SEND_MODAL = "send_modal",
  NONE = "none",
}
